module.exports = __webpack_public_path__ + "img/20180128143702.c976cf73.jpg";